import { useState, useMemo, useCallback } from 'react';
import { DataTable } from '@/components/common';
import { getOrganizationColumns } from './OrganizationTable.columns';
import type { Organization } from '../../types';

interface OrganizationTableProps {
  data: Organization[];
  renderEditForm?: (
    organization: Organization,
    onClose: () => void
  ) => React.ReactNode;
}

export function OrganizationTable({
  data,
  renderEditForm,
}: OrganizationTableProps) {
  const [editingOrganization, setEditingOrganization] = useState<Organization | null>(null);
  
  const handleEdit = useCallback((organization: Organization) => {
    setEditingOrganization(organization);
  }, []);
  
  const columns = useMemo(
    () => getOrganizationColumns({ onEdit: renderEditForm ? handleEdit : undefined }), 
    [handleEdit, renderEditForm]
  );

  return (
    <DataTable
      data={data}
      columns={columns}
      editingItem={editingOrganization}
      onEditingItemChange={setEditingOrganization}
      renderEditForm={renderEditForm}
      config={{
        enableColumnVisibility: true,
        enableSorting: true,
        enableFiltering: true,
        defaultPageSize: 10,
        pageSizeOptions: [5, 10, 20, 50],
        editDrawerTitle: 'Edit Organization',
        editDrawerDescription: 'Update organization information',
      }}
      testIdPrefix="organizations-table"
    />
  );
}
